import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@bitcoin-portal/verse-web-components/dist/Button';
import Link from '@bitcoin-portal/verse-web-components/dist/Link';

import NeedEth from '../../assets/need-eth.png';

import { Message } from './styled';

export const NeedEthModal: FunctionComponent = () => {
  return (
    <Message>
      <div>
        <img src={NeedEth} alt="ethereum graphic" />
      </div>
      <div style={{ maxWidth: 392 }}>
        <FormattedMessage id="global.modals.need-eth.need-eth-cover" />
      </div>
      <div style={{ width: '100%' }}>
        <Link newTab href="https://buy.bitcoin.com/eth/">
          <Button as="div" fullWidth>
            <FormattedMessage id="global.labels.getEth" />
          </Button>
        </Link>
      </div>
    </Message>
  );
};

export default NeedEthModal;
